import {
  Backdrop,
  Box,
  Button,
  Container,
  Divider,
  Fade,
  makeStyles,
  Modal,
  Typography,
} from '@material-ui/core';
import React, { useState } from 'react';
import BuzzInput from '../../../components/BuzzInput/BuzzInput';
import CloseIcon from '@material-ui/icons/Close';
import { useDispatch } from 'react-redux';
import {
  getPinocodesListAsync,
  postPincodesAsync,
} from './LaunchStore/launchSlice';
import useToast from '../../../hooks/useToast';

const useStyles = makeStyles((theme) => ({
  overAll: {
    maxWidth: 1452,
    backgroundColor: theme.palette.buzzContainerColor,
    borderRadius: 4,
    paddingLeft: 44,
    paddingRight: 44,
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 60,
    fontFamily: 'Rubik',
  },
  premiumModal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

function LaunchScreen() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { ErrorToast, SuccessToast } = useToast();

  const [type, setType] = useState('');
  const [file, setFile] = useState('');
  const [openModal, setOpenModal] = useState(false);
  const [state, setState] = useState();
  const [city, setCity] = useState();

  const handleOpenModal = () => {
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
    setType('');
  };

  const handleUploadDocument = (e) => {
    if (e.target.files.length) {
      setFile(e.target.files[0]);
    }
  };

  const handlePartialRollout = () => {
    const data = new FormData();
    const KEY = 'file';
    data.append(KEY, file);
    switch (type) {
      case 'Upload Pincodes':
        // TODO fix payload
        dispatch(
          postPincodesAsync({
            bodyData: data,
          })
        )
          .unwrap()
          .then((res) => {
            SuccessToast('Pincodes Launch Successfully');
          })
          .catch((err) => {
            ErrorToast(err.message);
          });
        break;
      case 'Download Pincodes CSV':
        dispatch(
          getPinocodesListAsync({
            city: city,
            state: state,
          })
        )
          .unwrap()
          .then((res) => {
            if (res.data.length === 0) {
              SuccessToast('Data Not Avilable!');
            } else {
              SuccessToast('CSV Download SuccessFully');
              var csv = 'Pincode,State,District,City,Area\n';

              //merge the data with CSV
              res.data.map(function (row) {
                csv +=
                  row.pincode +
                  ',' +
                  row.state +
                  ',' +
                  row.district +
                  ',' +
                  row.city +
                  ',' +
                  row.area;
                csv += '\n';
              });

              var hiddenElement = document.createElement('a');
              hiddenElement.href =
                'data:text/csv;charset=utf-8,' + encodeURI(csv);

              //provide the name for the CSV file to be downloaded
              hiddenElement.download = 'pincodes.csv';
              hiddenElement.click();
            }
          })
          .catch((err) => {
            ErrorToast(err.message);
          });
        break;
      default:
        break;
    }
    setFile('');
    setType('');
    handleCloseModal();
  };

  return (
    <Container className={classes.overAll}>
      <Box display="flex" flex={1} justifyContent="center" alignItems="center">
        <Box flex={1} flexGrow={1}>
          <Typography variant="h4" component="div">
            <Box fontWeight="fontWeightMedium">Launch</Box>
          </Typography>
          <Typography variant="subtitle1" color="textSecondary">
            Managing Launch Features
          </Typography>
        </Box>
      </Box>
      <Divider />
      <Box display="flex" flex={10} pt={5}>
        <Box mr={4}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              handleOpenModal();
              setType('Upload Pincodes');
            }}>
            Allow multiple Pincodes
          </Button>
        </Box>
        <Box mr={4}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              handleOpenModal();
              setType('Download Pincodes CSV');
            }}>
            Download Pincodes CSV
          </Button>
        </Box>
      </Box>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.premiumModal}
        open={openModal}
        onClose={handleCloseModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}>
        <Fade in={openModal}>
          <Box
            sx={{
              height: 220,
              width: 500,
              bgcolor: 'white',
              px: 2,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              py: 2,
              borderRadius: '8px',
            }}>
            <Box>
              <Box display="flex" justifyContent={'space-between'}>
                <Box
                  fontFamily={'Rubik'}
                  fontSize={18}
                  fontWeight="bold"
                  mb={2}>
                  {type}
                </Box>
                <Box sx={{ cursor: 'pointer' }}>
                  <CloseIcon fontSize="medium" onClick={handleCloseModal} />
                </Box>
              </Box>
              {type === 'Upload Pincodes' ? (
                <>
                  <Box mt={2}>
                    <input
                      accept=".csv"
                      id="upload-brochure"
                      type="file"
                      onChange={handleUploadDocument}
                    />
                    <Typography style={{ fontSize: 12 }}>
                      Imp: Upload a .csv file (max size 2mb)
                    </Typography>
                  </Box>
                </>
              ) : type === 'Download Pincodes CSV' ? (
                <>
                  <BuzzInput
                    size={'small'}
                    required
                    placeholder="Enter State"
                    autoFocus
                    fullWidth
                    name="state"
                    value={state}
                    onChange={(e) => setState(e.target.value)}
                  />
                  <Box mt={2}>
                    <BuzzInput
                      size={'small'}
                      required
                      placeholder="Enter City"
                      autoFocus
                      fullWidth
                      name="City"
                      value={city}
                      onChange={(e) => setCity(e.target.value)}
                    />
                  </Box>
                </>
              ) : null}
            </Box>
            <Box display={'flex'} justifyContent="flex-end">
              <Box mr={2}>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleCloseModal}>
                  Cancel
                </Button>
              </Box>
              <Button
                variant="contained"
                color="primary"
                onClick={handlePartialRollout}>
                Apply
              </Button>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </Container>
  );
}

export default LaunchScreen;
